import jQuery from "jquery";
(function (far, $) {
  far.modal = {};

  var _activeModal;

  //#region Public functions ====================================================

  far.modal.show = showModal;
  far.modal.close = closeModal;

  //#endregion

  function showModal(selector) {
    $("body").addClass("modal-open");
    $("html").css("overflow-y", "hidden");

    var $modal = $(selector);
    _activeModal = $modal;
    $modal.find(".js-closemodal").click(handleCloseModal);
    $modal.find(".modal__window").click(stopPropagation);

    $modal.show();
  }

  function closeModal() {
    $("body").removeClass("modal-open");
    $("html").css("overflow-y", "");

    _activeModal.hide();
  }

  function handleCloseModal(e) {
    e.preventDefault();
    closeModal();
  }

  function stopPropagation(e) {
    e.stopPropagation();
  }
})(window.far || (window.far = {}), jQuery);
